import React, { useState, useEffect } from "react";
import EmployeeGeneral from "./General/index";
import EmployeeNotification from "../EmployeeSettings/Notification/index";
import Settings from "components/Settings/SettingsMain/index";
import EmployeeSecurity from "../EmployeeSettings/Security/index";
import "./settings.scss";
import useTheme from "hooks/observer";

import Admin from "../OrganizationSetting/Admin/index";
import ManageUser from "../OrganizationSetting/ManageUser/ManageUser";
import ManageTeam from "../OrganizationSetting/ManageTeam/index";
import ManageRole from "../OrganizationSetting/ManageRole/index";
import AdvancedSettingsPage from "../OrganizationSetting/AdvancedSettings/index";

function EmployeeSetting({
  onProfileUpdated,
  backendOperations,
  handleManage,
  handleManageTeam,
  handleManageRole,
  handleManageAdvanced
}) {
  // Initialize activeTab from sessionStorage or default to 0
  const [activeTab, setActiveTab] = useState(() => {
    const savedTab = sessionStorage.getItem("activeTab");
    return savedTab !== null ? parseInt(savedTab, 10) : 0;
  });
  const [editProfile, setEditProfile] = useState(false);
  const NoBilling = true;

  // Save activeTab to sessionStorage whenever it changes
  useEffect(() => {
    sessionStorage.setItem("activeTab", String(activeTab || 0));
  }, [activeTab]);

  const hasAdminPerms = backendOperations && backendOperations.some(id => [44, 45, 81, 80, 2, 9, 41, 42, 43, 46, 47, 48, 128, 129].includes(id));

  const EmployeeTabs = [
    <EmployeeGeneral
      key={0}
      editProfile={editProfile}
      setEditProfile={setEditProfile}
      onProfileUpdated={onProfileUpdated}
    />,
    <EmployeeSecurity key={1} />,
    ...(hasAdminPerms ? [
      <Admin
        key={2}
        handleManage={handleManage}
        handleManageTeam={handleManageTeam}
        handleManageRole={handleManageRole}
        handleManageAdvanced={handleManageAdvanced}
        backendOperations={backendOperations}
      />
    ] : [])
  ];

  const theme = useTheme();

  return (
    <div
      className="EmployeeSetting"
      style={{ backgroundColor: theme === "light" ? "#fff" : "#211D25" }}
    >
      <Settings
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        NoBilling={NoBilling}
        isAdmin={hasAdminPerms}
      />
      <div
        className={`EmployeeSettingWrapper ${editProfile ? "EmployeeSettingScroll" : ""}`}
      >
        {EmployeeTabs[activeTab] ?? EmployeeTabs[0]}
      </div>
    </div>
  );
}

function EmployeeSettings({
  searchQuery,
  setSearchQuery,
  manageTeamSearchQuery,
  setManageTeamSearchQuery,
  manageRoleSearchQuery,
  setManageRoleSearchQuery,
  onManageUserChange,
  onProfileUpdated,
  backendOperations
}) {
  const [manageUser, setManageUser] = useState("");

  const handleManage = () => {
    setManageUser("manageUser");
    onManageUserChange("manageUser");
  };

  const handleManageTeam = () => {
    setManageUser("manageTeam");
    onManageUserChange("manageTeam");
  };

  const handleManageRole = () => {
    setManageUser("manageRole");
    onManageUserChange("manageRole");
  };

  const handleManageAdvanced = () => {
    setManageUser("advancedSettings");
    onManageUserChange("advancedSettings");
  };

  const handleManageUserChange = (newState) => {
    setManageUser(newState);
    onManageUserChange(newState);
  };

  return (
    <>
      {manageUser === "manageUser" ? (
        <ManageUser setManageUser={handleManageUserChange} searchQuery={searchQuery} setSearchQuery={setSearchQuery} />
      ) : manageUser === "manageTeam" ? (
        <ManageTeam setManageUser={handleManageUserChange} searchQuery={manageTeamSearchQuery} setSearchQuery={setManageTeamSearchQuery} />
      ) : manageUser === "manageRole" ? (
        <ManageRole setManageUser={handleManageUserChange} searchQuery={manageRoleSearchQuery} setSearchQuery={setManageRoleSearchQuery} />
      ) : manageUser === "advancedSettings" ? (
        <AdvancedSettingsPage setManageUser={handleManageUserChange} />
      ) : (
        <EmployeeSetting
          onProfileUpdated={onProfileUpdated}
          backendOperations={backendOperations}
          handleManage={handleManage}
          handleManageTeam={handleManageTeam}
          handleManageRole={handleManageRole}
          handleManageAdvanced={handleManageAdvanced}
        />
      )}
    </>
  );
}

export default EmployeeSettings;
